
// 1.

// import React, { useState, useEffect } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// import { MainSliderApi } from "../../../../../../../api/Api";
// import {
//   Typography,
//   Grid,
//   Box,
//   Divider,
// } from "@mui/material";

// const MainSlider = ({ stype }) => {
//   const [logData, setLogData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // एक्टिव स्लाइड को ट्रैक करने के लिए स्टेट
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const credentials = {
//     USER_ID: localStorage.getItem("LoginID"),
//     PLANT_code: localStorage.getItem("LCODE"),
//     pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//     Stype: stype,
//   };

//   const fetchLogData = async () => {
//     setLoading(true);
//     try {
//       const res = await MainSliderApi(credentials);
//       if (res?.data && Array.isArray(res.data)) {
//         const uniqueData = res.data.filter(
//           (item, index, self) =>
//             index === self.findIndex((t) => t.NAME === item.NAME)
//         );
//         setLogData(uniqueData);
//         setCurrentIndex(0); // नया डेटा आने पर पहली स्लाइड से शुरू करें
//       } else {
//         setLogData([]);
//       }
//     } catch (err) {
//       setError("Failed to fetch data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//     const intervalId = setInterval(fetchLogData, 300000);
//     return () => clearInterval(intervalId);
//   }, [stype]);

//   // जबरन ऑटो-स्क्रॉलिंग (Force Auto-scroll) के लिए इफेक्ट
//   useEffect(() => {
//     if (logData.length <= 1) return;

//     const scrollInterval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % logData.length);
//     }, 3000); // हर 3 सेकंड में बदलेगा

//     return () => clearInterval(scrollInterval);
//   }, [logData]);

//   return (
//     <Box className="container" sx={{ mt: 1 }}>
//       {loading && <Typography>Loading...</Typography>}
//       {error && <Typography color="error">{error}</Typography>}

//       {logData.length > 0 && (
//         <Carousel
//           selectedItem={currentIndex}                  // स्टेट से कंट्रोल हो रहा है
//           onChange={(index) => setCurrentIndex(index)} // यूजर क्लिक करे तो स्टेट अपडेट हो
//           infiniteLoop={true}
//           stopOnHover={false}
//           showArrows={true}
//           showIndicators={true}
//           showThumbs={false}
//           dynamicHeight={false}
//           centerMode={false}
//         >
//           {logData.map((item, index) => (
//             // Card और CardContent हटाकर यहाँ सिर्फ एक मुख्य Box रखा है जो पैरेंट के Card में फिट बैठेगा
//             <Box key={index} sx={{ p: 1 }}>
//               {/* Header */}
//               <Grid container justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography
//                   variant="subtitle1"
//                   color="primary"
//                   sx={{
//                     fontSize: "1.3rem",
//                     lineHeight: 1.2,
//                     py: 0,
//                   }}
//                 >
//                   {item.NAME}
//                 </Typography>
//               </Grid>
//               <Divider sx={{ mb: 0.5 }} />

//               {/* Two Column Layout */}
//               <Grid container spacing={2} sx={{ px: 0.5 }}>
//                 {/* Left Column */}
//                 <Grid item xs={6} sx={{ pr: 2 }}>
//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>⚡ Live:</Typography>
//                     <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                       {item.KW} <span style={{ color: "red" }}>kW</span>
//                     </Typography>
//                   </Grid>
//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>🌞 Today Energy:</Typography>
//                     <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                       {item.DAY_KWH} <span style={{ color: "red" }}>kWh</span>
//                     </Typography>
//                   </Grid>
//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>🏭 Make/Device:</Typography>
//                     <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                       {item.MAKE}
//                     </Typography>
//                   </Grid>
//                 </Grid>

//                 {/* Right Column */}
//                 <Grid item xs={6} sx={{ pl: 2 }}>
//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>
//                       {item.STS === "Online" ? "🟢" : "🔴"} Status:
//                     </Typography>
//                     <Typography
//                       sx={{
//                         color: item.STS === "Online" ? "green" : "red",
//                         fontWeight: "bold",
//                         fontSize: "0.8rem",
//                         textAlign: "right",
//                       }}
//                     >
//                       {item.STS}
//                     </Typography>
//                   </Grid>

//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>📈 TOTAL KWH:</Typography>
//                     <Box sx={{ textAlign: "right" }}>
//                       <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                         {item.TOT_GEN}
//                       </Typography>
//                       {/* <Typography sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
//                         ({item.KW_MAX_DATE})
//                       </Typography> */}
//                     </Box>


//                      {/* <Typography sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
//                         ({item.KW_MAX_DATE})
//                       </Typography> */}
//                   </Grid>

//                   <Grid container justifyContent="space-between">
//                     <Typography sx={{ fontSize: "0.8rem" }}>🕒 Date:</Typography>
//                     <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
//                       {item.E_DATE || "N/A"}
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Box>
//           ))}
//         </Carousel>
//       )}
//     </Box>
//   );
// };

// export default MainSlider;


// 2.

import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { MainSliderApi } from "../../../../../../../api/Api";
import {
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

const MainSlider = ({ stype }) => {
  const [logData, setLogData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // एक्टिव स्लाइड को ट्रैक करने के लिए स्टेट
  const [currentIndex, setCurrentIndex] = useState(0);

  const credentials = {
    USER_ID: localStorage.getItem("LoginID"),
    PLANT_code: localStorage.getItem("LCODE"),
    pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    Stype: stype,
  };

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await MainSliderApi(credentials);
      if (res?.data && Array.isArray(res.data)) {
        const uniqueData = res.data.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.NAME === item.NAME)
        );
        setLogData(uniqueData);
        setCurrentIndex(0); // नया डेटा आने पर पहली स्लाइड से शुरू करें
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
    const intervalId = setInterval(fetchLogData, 300000);
    return () => clearInterval(intervalId);
  }, [stype]);

  // जबरन ऑटो-स्क्रॉलिंग (Force Auto-scroll) के लिए इफेक्ट
  useEffect(() => {
    if (logData.length <= 1) return;

    const scrollInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % logData.length);
    }, 3000); // हर 3 सेकंड में बदलेगा

    return () => clearInterval(scrollInterval);
  }, [logData]);

  return (
    <Box className="container" sx={{ mt: 1 }}>
  {loading && <Typography>Loading...</Typography>}
  {error && <Typography color="error">{error}</Typography>}

  {logData.length > 0 && (
    <Carousel
      selectedItem={currentIndex}                  // स्टेट से कंट्रोल हो रहा है
      onChange={(index) => setCurrentIndex(index)} // यूजर क्लिक करे तो स्टेट अपडेट हो
      infiniteLoop={true}
      stopOnHover={false}
      showArrows={true}
      showIndicators={true}
      showThumbs={false}
      dynamicHeight={false}
      centerMode={false}
    >
      {logData.map((item, index) => (
        // Card और CardContent हटाकर यहाँ सिर्फ एक मुख्य Box रखा है जो पैरेंट के Card में फिट बैठेगा
        <Box key={index} sx={{ p: 1 }}>
          {/* Header */}
          <Grid container justifyContent="space-between" alignItems="center" mb={0.5}>
            <Typography
              variant="subtitle1"
              color="primary"
              sx={{
                fontSize: "1.3rem",
                lineHeight: 1.2,
                py: 0,
              }}
            >
               {item.NAME}
            </Typography>
          </Grid>
          <Divider sx={{ mb: 0.5 }} />

          {/* Two Column Layout */}
          <Grid container spacing={2} sx={{ px: 0.5 }}>
            {/* Left Column */}
            <Grid item xs={6} sx={{ pr: 2 }}>
              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>⚡ Live:</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.KW} <span style={{ color: "red" }}>kW</span>
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>🔌 kVA:</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.KVA}
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>🌞 kWh(I):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.TOT_GEN}
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📤 kWh(E):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.TOTAL_EXP}
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📈 VOLTAGE(V):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.VOLTAGE} 
                </Typography>
              </Grid>

             

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>⚙️ Make/Device:</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.MAKE}
                </Typography>
              </Grid>
            </Grid>

            {/* Right Column */}
            <Grid item xs={6} sx={{ pl: 2 }}>
              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>
                  {item.STS === "Online" ? "🟢" : "🔴"} Status:
                </Typography>
                <Typography
                  sx={{
                    color: item.STS === "Online" ? "green" : "red",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    textAlign: "right",
                  }}
                >
                  {item.STS}
                </Typography>
              </Grid>

              {/* <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📊 TOTAL KWH:</Typography>
                <Box sx={{ textAlign: "right" }}>
                  <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                    {item.TOT_GEN}
                  </Typography>
                </Box>
              </Grid> */}

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📥 kVAH(I):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.KVAH || ""}
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📤 kVAH(E):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.KVAH_EXP || ""}
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📐 PF:</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.PF || ""}
                </Typography>
              </Grid>

               <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>🔄 FREQUENCY(Hz):</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.FREQUENCY} 
                </Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: "0.8rem" }}>📅 Date:</Typography>
                <Typography sx={{ fontSize: "0.8rem", color: "primary.main" }}>
                  {item.E_DATE || ""}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Carousel>
  )}
</Box>
  );
};

export default MainSlider;